import React from 'react'
import { Button } from 'reactstrap'
import ListBox from './ListBox'
import { getPifOptions, PifSelectorProps } from './PifSelector'

export const PifListBox: React.FC<PifSelectorProps> = props => {

	const { onPifChanged } = props
	const { pifItems, coords } = props

	if (!coords.intakeKey) return null

	const pifOptions = getPifOptions(pifItems, coords)

	if (pifOptions.length == 0) return (
		<div className='text-center'>
			No Forms Defined
		</div>
	)

	const pifClearButton = !coords.pifId ? null : (
		<Button className='float-right' outline onClick={() => onPifChanged('')} title='Select Parent Intake'>
			<span className='font-weight-bold'>&#10531;</span>
		</Button>
	)

	return (
		<div>
			These Forms are in use for this Intake: {pifClearButton}
			<ListBox options={pifOptions} onChange={onPifChanged} value={coords.pifId} />
		</div>
	)
}
